<div class="modal-header">
    <button type="button" class="close" ng-click="$close()">×</button>
  <h3 class="modal-title">Editando ocorrência de {{$ctrl.title}}</h3>
</div>
<div class="modal-body edit-ocorrencia">
  <form class="form-horizontal" name="ocorrenciaForm">
    <div class="form-group" ng-class="{'has-error': $ctrl.isInvalid('estadio')}">
      <label for="estadio" class="control-label col-xs-4">Estádio</label>
      <div class="col-xs-8">
        <ui-select name="estadio" id="estadio" ng-model="$ctrl.data.estadio" required append-to-body="true">
          <ui-select-match placeholder="Estádio">
            {{$select.selected.abreviatura}} - {{$select.selected.descricao}}
          </ui-select-match>
          <ui-select-choices repeat="estadio in $ctrl.estadios | filter: $select.search">
            <span ng-bind-html="estadio.abreviatura + ' - ' + estadio.descricao | highlight: $select.search"></span>
          </ui-select-choices>
        </ui-select>
      </div>
    </div>
    <div class="form-group">
      <label for="observacao" class="control-label col-xs-4">Observações</label>
      <div class="col-xs-8">
        <textarea name="observacao" id="observacao" class="form-control" ng-model="$ctrl.data.observacao"></textarea>
      </div>
    </div>
    <div class="hr-line-dashed"></div>
    <div class="form-group" ng-class="{'has-error': $ctrl.data.items.length < 1}">
      <label for="add-type" class="control-label col-xs-4">Tipos</label>
      <div class="col-xs-8">
        <div class="btn-group">
          <button type="button" class="btn btn-info" id="add-type" ng-click="$ctrl.addType()">
            Adicionar tipo
            <i class="fa fa-plus"></i>
          </button>
          <button type="button" class="btn btn-white" ng-click="$ctrl.resetTypes()">
            Limpar
            <i class="fa fa-eraser"></i>
          </button>
        </div>
      </div>
    </div>
    <div ng-repeat="item in $ctrl.data.items" ng-class="item.type.tp_ocorrencia">
      <div class="row">
        <div class="col-xs-8 col-xs-push-4">
          <div class="hr-line-dashed"></div>
        </div>
      </div>
      <div class="form-group" ng-class="{'has-error': $ctrl.isInvalid('type'+$index)}">
        <label for="type{{$index}}" class="control-label col-xs-4">
          Tipo #{{$index + 1}}
        </label>
        <div class="col-xs-8">
          <div class="input-group">
            <ui-select name="type{{$index}}"
                       id="type{{$index}}"
                       ng-model="item.type"
                       required
                       append-to-body="true"
                       ng-change="$ctrl.resetType($index)">
              <ui-select-match placeholder="Tipo">{{$select.selected.descricao | capitalize}}</ui-select-match>
              <ui-select-choices repeat="type in $ctrl.tipos | filter: $select.search">
                <span ng-bind-html="type.descricao | capitalize | highlight: $select.search"></span>
              </ui-select-choices>
            </ui-select>
            <div class="input-group-btn">
              <button type="button" class="btn btn-white"
                      ng-click="$ctrl.removeType($index)" ng-disabled="$first && $last"
                      uib-tooltip="Remover tipo" tooltip-append-to-body="true">
                <i class="fa fa-trash text-danger"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
      <!-- Indicadores -->
      <ng-include ng-repeat="indicador in item.type.indicadores" src="'indicador/'+indicador.indicador.tipo+'.html'"></ng-include>
    </div>
  </form>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-white" ng-click="$close()">Cancelar</button>
  <button type="button" class="btn btn-primary" ng-disabled="!$ctrl.canSave()" ng-click="$ctrl.save()">
    Salvar
  </button>
</div>

<!-- Indicador Percentual -->
<script type="text/ng-template" id="indicador/percentual.html">
  <div class="row">
    <div class="col-xs-8 col-xs-push-4">
      <h3>{{indicador.indicador.titulo | capitalize}}</h3>
    </div>
  </div>
  <div class="form-group">
    <label for="indicador-{{$parent.$index}}-{{$index}}" class="control-label col-xs-4">
      {{indicador.indicador.descricao_valor1 | capitalize}}
    </label>
    <div class="col-xs-8">
      <input type="number"
             name="indicador-{{$parent.$index}}-{{$index}}"
             id="indicador-{{$parent.$index}}-{{$index}}"
             ng-model="item.value[indicador.cd_indicador].valor1"
             class="form-control"
             ng-change="$ctrl.setSituacao(item, indicador.cd_indicador)">
    </div>
  </div>
  <div class="form-group">
    <label for="indicador-{{$parent.$index}}-{{$index}}" class="control-label col-xs-4">
      {{indicador.indicador.descricao_valor2 | capitalize}}
    </label>
    <div class="col-xs-8">
      <input type="number"
             name="indicador-{{$parent.$index}}-{{$index}}"
             id="indicador-{{$parent.$index}}-{{$index}}"
             ng-model="item.value[indicador.cd_indicador].valor2"
             class="form-control"
             ng-change="$ctrl.setSituacao(item, indicador.cd_indicador)">
    </div>
  </div>
  <div class="form-group">
    <label class="control-label col-xs-4">Percentual</label>
    <div class="col-xs-8">
      <p class="lead m-b-n">
        {{item.value[indicador.cd_indicador].percentual || 0 | number: 2}} %
      </p>
    </div>
  </div>
  <div class="row" ng-show="item.value[indicador.cd_indicador].situacao">
    <div class="col-xs-8 col-xs-push-4">
      <div class="progress progress-bar-ocorrencia">
        <div class="progress-bar" style="min-width: 3em; max-width: 100%;"
             ng-style="{width: (item.value[indicador.cd_indicador].percentual || 0)+'%'}"
             ng-class="{
               'bg-extremo': item.value[indicador.cd_indicador].situacao.id === 5,
               'bg-alerta': item.value[indicador.cd_indicador].situacao.id === 4,
               'bg-controle': item.value[indicador.cd_indicador].situacao.id === 3,
               'bg-alto_equilibrio': item.value[indicador.cd_indicador].situacao.id === 2,
               'bg-equilibrio': item.value[indicador.cd_indicador].situacao.id === 1
             }">
          {{item.value[indicador.cd_indicador].situacao.description}}
        </div>
      </div>
    </div>
  </div>
</script>

<!-- Indicador Booleano -->
<script type="text/ng-template" id="indicador/boolean.html">
  <div class="form-group">
    <label class="control-label col-xs-4">{{indicador.indicador.titulo | capitalize}}</label>
    <div class="col-xs-8">
      <div class="switch">
        <div class="onoffswitch">
          <input type="checkbox"
                 name="indicador-{{$parent.$index}}-{{$index}}"
                 id="indicador-{{$parent.$index}}-{{$index}}"
                 ng-model="item.value[indicador.cd_indicador].valor1"
                 class="onoffswitch-checkbox">
          <label class="onoffswitch-label" for="indicador-{{$parent.$index}}-{{$index}}">
            <span class="onoffswitch-inner"></span>
            <span class="onoffswitch-switch"></span>
          </label>
        </div>
      </div>
    </div>
  </div>
</script>

<!-- Indicador Seleção -->
<script type="text/ng-template" id="indicador/texto.html">
  <div class="form-group">
    <label for="indicador-{{$parent.$index}}-{{$index}}" class="control-label col-xs-4">{{indicador.indicador.titulo | capitalize}}</label>
    <div class="col-xs-8">
      <select name="indicador-{{$parent.$index}}-{{$index}}" id="indicador-{{$parent.$index}}-{{$index}}"
              class="form-control" ng-model="item.value[indicador.cd_indicador].valor1"
              ng-change="$ctrl.setSituacao(item, indicador.cd_indicador)">
        <option value="" disabled>Selecione</option>
        <option value="Baixa">Baixa</option>
        <option ng-if="indicador.numero_faixas === 4" value="Baixa Média">Baixa Média</option>
        <option value="Média">Média</option>
        <option value="Alta">Alta</option>
        <option ng-if="indicador.numero_faixas === 5" value="Extremo">Extremo</option>
      </select>
    </div>
  </div>
</script>

<!-- Indicador Valor -->
<script type="text/ng-template" id="indicador/valor.html">
  <div class="form-group">
    <label for="indicador-{{$parent.$index}}-{{$index}}" class="control-label col-xs-4">{{indicador.indicador.titulo | capitalize}}</label>
    <div class="col-xs-8">
      <input type="text" name="indicador-{{$parent.$index}}-{{$index}}" id="indicador-{{$parent.$index}}-{{$index}}"
             class="form-control" ng-model="item.value[indicador.cd_indicador].valor1"
             ng-change="$ctrl.setSituacao(item, indicador.cd_indicador)">
    </div>
  </div>
  <div class="row" ng-show="item.value[indicador.cd_indicador].situacao">
      <div class="col-xs-8 col-xs-push-4">
        <div class="progress progress-bar-ocorrencia">
          <div class="progress-bar" style="min-width: 3em; max-width: 100%;"
               ng-style="{width: (+item.value[indicador.cd_indicador].valor1 || 0) / (+indicador.controle + 1) * 100 + '%'}"
               ng-class="{
                 'bg-extremo': item.value[indicador.cd_indicador].situacao.id === 5,
                 'bg-alerta': item.value[indicador.cd_indicador].situacao.id === 4,
                 'bg-controle': item.value[indicador.cd_indicador].situacao.id === 3,
                 'bg-alto_equilibrio': item.value[indicador.cd_indicador].situacao.id === 2,
                 'bg-equilibrio': item.value[indicador.cd_indicador].situacao.id === 1
               }">
            {{item.value[indicador.cd_indicador].situacao.description}}
          </div>
        </div>
      </div>
    </div>
</script>
